<template>
  <PopupBase
    class="popup-brands"
    :size="POPUP.Size.small"
    v-bind="$attrs"
  >
    <div v-if="brands">
      <div class="h3 brands--header">
        {{ $tv('popupHeadline', 'brands') }}
      </div>
      <div class="popup-brands-container">
        <div
          v-for="brand in brands"
          :key="brand.id"
          class="brand__tile"
        >
          <div class="brand__headline">
            <img
              v-if="getLogoUrl(brand)"
              class="brand__logo"
              :src="brand.SmallLogo.url"
              :alt="brand.Brand"
            >
            <span
              class="h5 brand__name"
              v-text="brand.Brand"
            />
          </div>
          <Markdown
            class="brand__content"
            :text="brand.BrandDescription"
          />
        </div>
      </div>
    </div>
  </PopupBase>
</template>

<script>
import PopupBase from '~/components/popup/PopupBase.vue'
import {POPUP} from '~/assets/js/constants'

export default {
  name: 'PopupOrderDetails',
  components: {PopupBase},
  props: {
    order: {
      type: Object,
      required: false,
      default() {
        return {
        }
      }
    },
    isLoading: {
      type: Boolean,
      required: false,
      default() {
        return false
      }
    },
    brands: {
      type: Array,
      required: false,
      default() {
        return null
      }
    }
  },
  data() {
    return {
      POPUP
    }
  },
  methods: {
    getLogoUrl: function (brand) {
      // eslint-disable-next-line eqeqeq
      if (brand?.BigLogo?.url != null) {
        return brand?.SmallLogo?.url
      }
      return null
    }
  }
}
</script>

<style lang="scss">
.popup-brands {
  position: relative;

  @include breakpoint-down($md) {
    z-index: 1001;
  }

  @include breakpoint-up($md) {
    .popup__wrapper {
      max-width: 50rem;
    }
  }

  .brands--header {
    position: relative;
    top: -.5625rem;
    padding-right: 3rem;
    line-height: 1.25;
    color: $color__primary;

    @include breakpoint-down($md) {
      padding-right: 3.25rem; // a touch more space on small screens
      margin-bottom: 0.75rem;
    }
  }

  .brand__tile {
    position: relative;
    padding: .5rem 0;

    .brand__headline {
      display: flex;
      align-items: center;
    }

    .brand__name {
      position: relative;
      vertical-align: top;
      color: $color__primary;
      padding-top: 0;
    }

    .brand__logo {
      position: relative;
      height: 1.25rem;
      width: auto;
      margin-right: .5rem;
    }

    .brand__content {
      position: relative;
      padding-top: .5rem;
      font-weight: $base-text-font-weight-light;

      ul {
        margin: 0;
        margin-block-start: 0;
        margin-inline-start: 0;
        padding-inline-start: 1.5rem;
      }
    }
  }
}
</style>
